<!--
 * @Description:  发展历程
 * @Author: wangying
 * @Date: 2021-09-29 09:45:28
-->
<template>
  <div>
    <div class="title">
      <ListTitle :headerNmae="headerNmaeCh" :headerNmaeCh="headerNmae"></ListTitle>
    </div>
    <div class="contentsy">
      <div v-html="content"></div>

    </div>
  </div>
</template>
<script>
import '@/css/content.less'
import { articleDetail } from '@/api'
import ListTitle from "@/components/reuse/listTitle";

export default {
  components: {
    ListTitle,
  },
  data() {
    return {
      headerNmae: null,
      headerNmaeCh: null,
      content: null
    }
  },
  mounted() {
    this.hub.$emit('tatleNames')
    this.hub.$emit('theCover', this.$route.meta.flagNam)
    this.hub.$emit('scrollToz')

    const params = {
      articleId: 'WZNR201610311925050035',
      isEn: this.$store.state.language === 'en' ? 1 : 0
    }
    articleDetail(params).then((res) => {
      console.log(res.data);
      this.content = res.data.content
      this.headerNmae = res.data.description
      this.headerNmaeCh = res.data.title

    })
  }
}
</script>
<style lang="less" scoped>
.title {
  margin: 50px 0;
}
</style>